<template>
  <div class="set_smail_line" v-loading="disabled">
    <el-form :hide-required-asterisk='true' :model="locForm" :rules="locRules" class="set_form" ref="locForm">
      <el-form-item label="" class="info_box" prop="location">
        <i class="location" :style="LocationIcon!=null?'background-image:url('+LocationIcon+')':''"  v-if="LocationIcon!=null"></i>
        <el-select :class="LocationIcon!=null?'info_ipt':''"  :placeholder="$t('base.chooseLocation')" v-model="locForm.location" @change='changeLocation'>
          <el-option class="locationelOption" :label="item.EnName" :value="item.EnName" v-for="(item,index) in locationOption" :key='index'>
            <div class="locationOption">
              <img :src="item.IconUrl">
              <span>{{item.EnName}}</span>
            </div>
          </el-option>
        </el-select>
      </el-form-item>
      <div class="set_btn">
        <el-button :disabled="disabled" @click="resetForm('locForm')">{{ $t('base.cancel') }}</el-button>
        <el-button :disabled="disabled" type="primary" @click="submitForm('locForm')">{{ $t('base.save') }}</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'countries',
  data() {
    return {
      disabled: false,
      LocationIcon: '',
      locationOption: '',
      locForm: {
        location: ''
      },
      value: '',
      locRules: {
        location: [
          { required: true, message: this.$t('base.chooseLocation'), trigger: 'change' }
        ],
      }
    }
  },
  props: {
    list: Object,
  },
  created() {
    this.getNationIcons()
    this.locForm.location = this.list.LocationName
    this.LocationIcon = this.list.LocationIcon
  },
  methods: {
    //获取全部国家图标地址
    getNationIcons() {
      let that = this
      this.$get(this.$interface.GetAllNationIcons, '').then(res => {
        if (res.Result != 0) {
          that.locationOption = res.Data
        }
      })
    },
    changeLocation(e) {
      let that = this
      that.locationOption.map(res => {
        if (res.EnName == e) {
          that.LocationIcon = res.IconUrl
        }
      })
    },
    resetForm(formName) {
      let that = this;
      that.$refs[formName].resetFields();
      that.$emit('getData', this.list, 'location')
    },
    submitForm(formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.disabled = true
          let LocationIcon = '';
          let LocationName = '';
          that.locationOption.map(res => {
            if (res.EnName == that.locForm.location) {
              LocationIcon = res.IconUrl
              LocationName = res.EnName
            }
          })
          let data = { Id: that.list.Id, locationIcon: LocationIcon, locationName: LocationName }
          this.$post(this.$interface.ForeignChangeLocationIcon, data).then(res => {
            if (res.Result != 0) {
              that.$emit('getData', this.list, 'location')
            } else {

            }
          })

        } else {
          //console.log('error submit!!');
          return false;
        }
      });
      //this.$emit('getData', false, 'location')
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/settings.css";

/deep/.info_ipt .el-input .el-input__inner {
  padding: 0 15px 0 43px;
}

.locationOption {
  display: flex;
  align-items: center;
}

.locationOption img {
  width: 24px;
  height: 17px;
  margin-right: 10px;
}

/deep/ .locationelOption.hover,
.locationelOption:hover,
.locationelOption.selected {
  background-color: #f8f8f8;
}

</style>



// WEBPACK FOOTER //
// src/components/form/location.vue